import { forwardRef } from 'react';
import { Input as HeadlessInput, InputProps as HeadlessInputProps } from '@headlessui/react';

type NativeInputProps = Omit<HeadlessInputProps, 'size'>;

interface InputProps extends NativeInputProps {
  className?: string;
  inline?: boolean;
  size?: 'sm' | 'md' | 'lg';
  rounded?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | 'full';
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, inline = false, size = 'md', rounded = 'md', ...rest }, ref) => {
    const sizes = {
      sm: 'h-10 px-3',
      md: 'h-12 px-4',
      lg: 'h-16 px-6',
    };

    const roundedClasses = {
      sm: 'rounded-sm',
      md: 'rounded-md',
      lg: 'rounded-lg',
      xl: 'rounded-xl',
      '2xl': 'rounded-2xl',
      '3xl': 'rounded-3xl',
      full: 'rounded-full',
    };

    return (
      <HeadlessInput
        ref={ref}
        className={`border-none bg-[#171717] text-white focus:not-data-focus:outline-none data-focus:outline-2 data-focus:-outline-offset-2 data-focus:outline-white/25 placeholder:text-[#ffffff40] no-spinner ${className} ${inline ? '' : 'w-full'} ${sizes[size]} ${roundedClasses[rounded]}`}
        {...rest}
      />
    );
  },
);

Input.displayName = 'Input';

export default Input;
